import React, {useState, useEffect, useRef} from "react";
import "./SwitchButton.scss";

function SwitchButton({leftLabel, rightLabel, onClickLeft, onClickRight, className}) {
    const [switchBtn, setSwitchBtn] = useState(true);
    const [pillStyle, setPillStyle] = useState({ width: 0, transform: 'translateX(0)' });
    const leftRef = useRef(null);
    const rightRef = useRef(null);

    useEffect(() => {
        const activeRef = switchBtn ? leftRef.current : rightRef.current;
        if (activeRef) {
            setPillStyle({
                width: activeRef.offsetWidth,
                transform: `translateX(${activeRef.offsetLeft - 4}px)`
            });
        }
    }, [switchBtn, leftLabel, rightLabel]);

    function onLeftClicAction() {
        setSwitchBtn(true);
        onClickLeft();
    }

    function onRightClickAction() {
        setSwitchBtn(false);
        onClickRight();
    }

    return (
        <div className={`d-flex justify-center mb-1-r ${className}`}>
            <div className="switch-container">
                <div className="switch-pill" style={pillStyle}></div>
                <div ref={leftRef} className={switchBtn ? "switch-btn active" : "switch-btn"}
                     onClick={onLeftClicAction}>
                    <p>{leftLabel}</p>
                </div>
                <div ref={rightRef} className={switchBtn ? "switch-btn" : "switch-btn active"}
                     onClick={onRightClickAction}>
                    <p>{rightLabel}</p>
                </div>
            </div>
        </div>
    );
}

export default SwitchButton;